import {scrollMe} from "./functions";

import './components/vh';

jQuery(function ($) {
    scrollMe($('a[href^="#"]'));
});